import SocketService from '../SocketService';
export var pingMessageRequest = function (token) {
    return SocketService.createEncodedMessage({
        kind: 'pingMessage',
        pingMessage: {
            token: token
        }
    });
};
